import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import AuthCallbackBroadcast from '@/broadcasts/AuthCallbackBroadcast';
import { TenantLogo } from '@/components/TenantLogo';
import { Button } from '@/components/ui/Button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export function AuthCallback() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.AuthCallback',
  });
  useEffect(() => {
    AuthCallbackBroadcast.sendMessage({ success: true });
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="mb-4 flex h-12 w-full items-center justify-center rounded-full">
            <TenantLogo />
          </div>
          <CardTitle className="text-center">{t('title')}</CardTitle>
          <CardDescription className="text-center">
            {t('description')}
          </CardDescription>
        </CardHeader>

        <CardContent>
          <p className="text-center text-sm text-muted-foreground">
            {t('message')}
          </p>
        </CardContent>

        <CardFooter className="flex justify-center">
          <Link to={ROUTE_PATHS.SETTINGS}>
            <Button>{t('returnButton')}</Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
}
